let products_on_page = document.querySelector('.products-on-page');
let nextURL = products_on_page.dataset.nexturl;
const load_more_btn = document.querySelector('.load-more__btn');
const loadMoreSpinner = document.querySelector('.loading-overlay__spinner');

function showSpinner() {
  loadMoreSpinner.classList.remove('hidden');
}

function hideSpinner() {
  loadMoreSpinner.classList.add('hidden');
}

function countLiItems() {
  return products_on_page.querySelectorAll('li.grid__item:not([class*="editorial"])').length;
}

async function loadMoreProducts() {
  if (!nextURL) return;

  try {
    showSpinner();

    const response = await fetch(nextURL);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const next_page = await response.text();
    const doc = new DOMParser().parseFromString(next_page, 'text/html');
    const new_product = doc.querySelector('.products-on-page');

    if (!new_product) {
      console.error('Could not find .products-on-page in fetched HTML');
      return;
    }

    products_on_page.insertAdjacentHTML('beforeend', new_product.innerHTML);
    nextURL = new_product.dataset.nexturl || null;

    const count = countLiItems();
    document.querySelector('.products-showing').textContent = count;

    if (!nextURL) {
      document.querySelector('.load--more').classList.add('hidden');
    }

    initializeSwatches();

  } catch (err) {
    console.error('Failed to load more products:', err);
  } finally {
    hideSpinner();
  }
}

load_more_btn.addEventListener('click', loadMoreProducts);
